export default function state() {
  return {
    account: {
      id: undefined
    },
    user: {}
  };
}
